import camelize from '@/services/functions/camelize';

export default function createPriceModification(data) {
  if (!data) {
    return null;
  }

  return {
    costAfter: data.cost_after,
    costBefore: data.cost_before,
    costDiff: data.cost_diff,
    id: data.id,
    modifierId: data.modifier_id,
    hasCountries: data.has_countries ?? false,
    name: data.name,
    isSpeedup: data.is_speedup,
    isHotOffer: data.is_hot_offer ?? false,
    type: camelize(data.type),
  };
}
